module.exports = __webpack_public_path__ + "homeStatic/img/img02.0cd4261.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/img02.png
// module id = R7GA
// module chunks = 1